export const NOT_STAGGERED_TIRE_TYPE = 'tire'

export const STAGGERED_SIZE_LABEL = {
  rearTire: 'REAR',
  frontTire: 'FRONT'
}

export const OTDP_MESSAGE_PHONE_REPLACE = '<selected store number>'

export const SAVE_FOR_LATER_BTN_TEXT = '+ SAVE FOR LATER'
export const ITEM_TEXT = 'Item'
export const SAVED_FOR_LATER_TEXT = 'SAVED FOR LATER'
export const SCROLL_TEXT = 'SCROLL'
